import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { CatalogProvider } from './context/CatalogContext';
import { LanguageProvider } from './context/LanguageContext';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Collections from './pages/Collections';
import CollectionDetail from './pages/CollectionDetail';
import AllWatches from './pages/AllWatches';
import ProductDetail from './pages/ProductDetail';
import FAQ from './pages/FAQ';
import OrderTracking from './pages/OrderTracking';
import Contact from './pages/Contact';
import NotreHistoire from './pages/NotreHistoire';
import LegalPage from './pages/LegalPage';
import Cart from './pages/Cart';
import ChatWidget from './components/ChatWidget';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App bg-ivory min-h-screen">
      <LanguageProvider>
      <CartProvider>
        <CatalogProvider>
        <BrowserRouter>
          <ScrollToTop />
          <TopBar />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:slug" element={<CollectionDetail />} />
            <Route path="/montres" element={<AllWatches />} />
            <Route path="/produit/:slug" element={<ProductDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/suivi" element={<OrderTracking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/notre-histoire" element={<NotreHistoire />} />
            <Route path="/panier" element={<Cart />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
          </Routes>
          <Footer />
          <ChatWidget />
        </BrowserRouter>
        </CatalogProvider>
      </CartProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
